<h2 mat-dialog-title>Add Organisation</h2>
<mat-dialog-content>
  <form id="map-org-form" [formGroup]="orgForm" (ngSubmit)="submit()">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput [formControl]="name" />
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>URL</mat-label>
        <mat-hint>URLs must include the protocol (ex: https://example.org)</mat-hint>
        <input matInput [formControl]="url" />
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Role</mat-label>
        <mat-select multiple [formControl]="roles">
          @for (role of orgRoles | keyvalue; track role.key) {
            <mat-option value="{{ role.value }}">{{ role.key }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </p>

    @if (this.roles && this.roles.value?.includes(orgRoles['Archive'])) {
      <h3>Archive info</h3>
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Copies</mat-label>
          <input type="number" matInput [formControl]="copies" />
        </mat-form-field>
      </p>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Room</mat-label>
          <input matInput [formControl]="room" />
        </mat-form-field>
      </p>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Storage Reference</mat-label>
          <input matInput [formControl]="storageRef" />
        </mat-form-field>
      </p>
    }

    <mat-dialog-actions align="end">
      <button mat-flat-button type="submit" [disabled]="orgForm.pristine || !orgForm.valid">
        Save
      </button>
      <button mat-button type="button" (click)="cancel()">Cancel</button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>
